import * as yup from "yup";
import { InferType } from "yup";
import { ExceptionTypes } from "src/models/staffPriceExceptions/StaffPriceExceptionTypes";

export const skuExceptionSchema = yup
    .object({
        id: yup.string().nullable(),

        type: yup
        .array()
        .of(yup.mixed<ExceptionTypes>().oneOf(Object.values(ExceptionTypes)))
        .min(1, "Please select an exception type"),
    
        details: yup
        .array()
        .of(yup.string().required("SKU is required"))
        .required("SKU is required")
        .min(1, "Please select a SKU"),
    
        price: yup
        .number()
        .typeError("Price is required")
        .required("Price is required")
        .min(0, "Price must be zero or more")
        .test(
          "max-2-decimals",
          "Price can have at most 2 decimal places",
          (value) => value === undefined || /^\d+(\.\d{1,2})?$/.test(value.toString())
        ),

        authorisedBy: yup
        .string()
        .required("Authorised by is required"),
    
        comment: yup
        .string()
        .required("Comment is required")
        .max(100, "Comment must be at most 100 characters"),

        isActive: yup.boolean().nullable()
});

// Schema for entire form model
export const createExceptionSchema = yup.object({
  skuExceptions: yup
    .array()
    .of(skuExceptionSchema)
    .min(1, "Please add at least one SKU exception")
});

export type CreateExceptionModel = InferType<typeof createExceptionSchema>;